import React from 'react'

export default function ProjectsGroup ({letter, projects}) {
  return (
    <div className={'mt-projects-archive__projects-group'}>
      <div className={'mt-projects-archive__projects-group--title'}>{letter}</div>
      <div className={'mt-projects-archive__projects-group--inner'}>
        {projects.map(project => <ProjectItem key={project.id} project={project} />)}
      </div>
    </div>
  )
}

function ProjectItem ({project}){
  return (
    <a href={project.link} className={'mt-projects-archive__projects-group--project'}>
      {project.label}
    </a>
  )
}
